import React from "react"
import { InnerMenuItemTypes } from "../CommandBar"
import { InnerMenuItem } from "./InnermenuItem";

type InnerMenuListingType = {
    innerMenuItems: InnerMenuItemTypes[];
    handleClose: () => void;
}

export const InnerMenuListing: React.FC<InnerMenuListingType> = ({
    innerMenuItems,
    handleClose
}) => {
    return (
        <>
            {innerMenuItems.map(x => (
                <InnerMenuItem 
                    onClick={handleClose}
                    languageText={x.languageText}
                    languageValue={x.languageValue}
                />
            ))}
        </>
    )   
}